import React from 'react';
import { TrendingDown, DollarSign } from 'lucide-react';
import { AlertTriangle } from 'lucide-react';

const ProfitLeakStats = () => {
  return (
    <section className="py-16 relative overflow-hidden" style={{ backgroundColor: '#0B1F3A' }}>
      {/* Professional gold/yellow swirl decoration */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox="0 0 1200 400"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M-100,200 C100,80 300,350 500,180 C700,10 900,300 1100,120 C1200,60 1300,200 1400,150" fill="none" stroke="rgba(212,175,55,0.12)" strokeWidth="120" strokeLinecap="round"/>
        <path d="M-50,300 C150,180 350,380 550,250 C750,120 950,350 1150,200" fill="none" stroke="rgba(245,197,66,0.08)" strokeWidth="80" strokeLinecap="round"/>
        <path d="M0,100 C200,250 400,50 600,200 C800,350 1000,100 1200,250" fill="none" stroke="rgba(212,175,55,0.06)" strokeWidth="60" strokeLinecap="round"/>
      </svg>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Alert Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: 'rgba(239, 68, 68, 0.2)', color: '#ef4444' }}>
            <AlertTriangle size={16} />
            <span>The Hidden Cost Most Businesses Miss</span>
          </div>
          
          {/* Main Stat */}
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
              <span style={{ color: '#D4AF37' }}>$50,000</span>/month → 
              <span style={{ color: '#ef4444' }}> $1,500 lost</span> → 
              <span style={{ color: '#ef4444' }}> $18,000/year</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Most businesses never realize this is happening — that's money slipping away unnoticed every single month.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(239, 68, 68, 0.2)' }}>
                <TrendingDown style={{ color: '#ef4444' }} size={28} />
              </div>
              <h3 className="text-2xl font-bold mb-2 text-white">2-4%</h3>
              <p className="text-gray-300">Average processing fee eating into your profits</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)' }}>
                <DollarSign style={{ color: '#D4AF37' }} size={28} />
              </div>
              <h3 className="text-2xl font-bold mb-2 text-white">$18,000+</h3>
              <p className="text-gray-300">Average annual loss for mid-size businesses</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(34, 197, 94, 0.2)' }}>
                <DollarSign style={{ color: '#22C55E' }} size={28} />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ color: '#22C55E' }}>100%</h3>
              <p className="text-gray-300">Fee recovery possible with our payment systems</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfitLeakStats;
